import { render, staticRenderFns } from "./ListBuyBoxFilter.vue?vue&type=template&id=459df79d&scoped=true"
import script from "./ListBuyBoxFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListBuyBoxFilter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ListBuyBoxFilter.vue?vue&type=style&index=0&id=459df79d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459df79d",
  null
  
)

export default component.exports